import { render, staticRenderFns } from "./OurCollectionComponent.vue?vue&type=template&id=9bcca768&scoped=true&"
import script from "./OurCollectionComponent.vue?vue&type=script&lang=js&"
export * from "./OurCollectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcca768",
  null
  
)

export default component.exports